import './InfoTooltip.css'
import cx from 'classnames'
import { InfoIcon } from '../icons'
import { Tooltip } from '../Tooltip/Tooltip'

type Size = 'small' | 'medium' | 'large'

const sizeClasses: Record<Size, string> = {
  small: 'info-tooltip-small',
  medium: 'info-tooltip-medium',
  large: 'info-tooltip-large'
}

export function InfoTooltip({
  content,
  position = 'top',
  size = 'medium'
}: {
  content: React.ReactNode
  position?: 'top' | 'bottom'
  size?: Size
}) {
  return (
    <Tooltip content={content} position={position} variant="info">
      <InfoIcon className={cx('info-tooltip-icon', sizeClasses[size])} />
    </Tooltip>
  )
}
